
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.666 4.167c0-.92.746-1.667 1.667-1.667h13.333c.92 0 1.667.746 1.667 1.667v11.666c0 .92-.746 1.667-1.667 1.667H3.333c-.92 0-1.667-.746-1.667-1.667V4.167z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.5 14.166V5.833L14.167 10 7.5 14.166z","fill":"#141414"}})])
          )
        }
      }
    